const routes = [];

const requireRoute = require.context('.', false, /^(?!.*(index)).*\.js$/);

requireRoute.keys().forEach((fileName) => {
    routes.push(...requireRoute(fileName).default);
});

export default routes;
